import { phonePattern } from "../../const/regexPatterns";

export function validatePhone({
  phone,
  minLength = 10,
  maxLength = 15,
  fieldName = "Phone number",
  required = true
}: {
  phone: string;
  minLength?: number;
  maxLength?: number;
  fieldName?: string;
  required?: boolean;
}): string | undefined {
  if (!phone) {
    if (required) return `${fieldName} is required.`;
    return undefined;
  }

  if (phone.length > maxLength || phone.length < minLength) {
    return `${fieldName} must be between ${minLength} and ${maxLength} characters.`;
  }
  if (!phonePattern.test(phone)) {
    return `${fieldName} can only contain digits, spaces, hyphens, and parentheses.`;
  }
}
